import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom'
import { signOutUser } from '../actions/auth';
import { getUserProfile } from '../actions/user';
import { isLogged } from '../utils/common';

const PrivateRoute = (props) => {
    const { Component } = props
    const navigate = useNavigate();
    const isLoggedIn = isLogged();
    const dispatch= useDispatch() ;
    const {user , error } = useSelector(store => store.userreducer)

    useEffect(() => {
        if (isLoggedIn && user === undefined && error?.message !== "Oops Something went wrong") {
            dispatch(getUserProfile())
        }else if (isLoggedIn === false){
            navigate("/userdetails")
        }else if(error?.message === "Oops Something went wrong") {
            dispatch(signOutUser(navigate))
        }
    }, [error])
    return <>
        <Component />
    </>
}

export default PrivateRoute
